import { Values } from '@lib/interfaces/form';
import _get from 'lodash/get';
import {
  FormChecklistTemplateCreateInputObject,
  FormChecklistTemplateOption,
  FormChecklistTemplateUpdateInputObject,
} from 'graphql-common';
import ChecklistFieldNames from '@lib/enums/fieldNames/checklistFieldNames';

export default function getPreparedDataFromValues(args: {
  values: Values;
}):
  | FormChecklistTemplateCreateInputObject
  | FormChecklistTemplateUpdateInputObject {
  const { values } = args;
  const options = _get(values, ChecklistFieldNames.Options) as Values[];
  return {
    name: _get(values, ChecklistFieldNames.Name) as string,
    description: _get(values, ChecklistFieldNames.Description) as string,
    options: options.map(({ values: optionValues, id, position }) => ({
      value: _get(optionValues, 0),
      id,
      position,
    })) as FormChecklistTemplateOption[],
  };
}
